module.exports = __webpack_public_path__ + "img/06-oval-convex-3.abb215a7.svg";